import { saveAs } from "file-saver";
export default {
  async fetchData({ commit }, params) {
    const type = sessionStorage.getItem("selectedButton") || "residential";
    try {
      const query = new URLSearchParams(params).toString();
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/table/${type}?${query}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();

      commit("setPagination", {
        totalItems: responseData.totalItems,
        totalPages: responseData.totalPages,
        currentPage: responseData.currentPage,
        data: responseData.data,
        filters: params,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async downloadCSV({ state }) {
    const data = state.pagination.pagination.data;

    try {
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/table/download-csv`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const blob = await response.blob();
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        const now = new Date();
        const formattedDate = `${String(now.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(now.getDate()).padStart(2, "0")}-${now.getFullYear()}`;

        const fileName = `Table_CSV_${userData.name}_${userData.last_name}_${formattedDate}.csv`;
        saveAs(blob, fileName);
      } else {
        console.error("Error downloading the CSV");
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  },

  async downloadFullCSV({state}) {
    const query = new URLSearchParams(state.pagination.pagination.filters);
    query.append("type", sessionStorage.getItem("selectedButton"));
    try {
      const url = `${process.env.VUE_APP_API_BASE_URL}/lead-history/table/download-full-csv?${query.toString()}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        const now = new Date();
        const formattedDate = `${String(now.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(now.getDate()).padStart(2, "0")}-${now.getFullYear()}`;

        const fileName = `Full_CSV_${userData.name}_${userData.last_name}_${formattedDate}.csv`;
        saveAs(blob, fileName);
      } else {
        console.error("Error downloading the CSV");
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  },
};
